export enum FormBuilderElementTypeIdentifier {
	Unknown = 0,
	Input = 1,
	Select = 2,
	Image = 3,
	LineBreak = 4,
	Heading = 5,
	Paragraph = 6
}
